import { Reviews } from 'widgets/Reviews'
import '../styles/index.scss'
import { useEffect, useState } from 'react'
import { SiteNames } from 'widgets/Reviews/ui/Reviews'



export const App = () => {
  const [siteName, setSiteName] = useState<SiteNames>('fintok_es')

  useEffect(() => {
    const rootElement = document.querySelector('#reviews_root') as HTMLElement

    const siteName = rootElement.dataset.siteName as SiteNames
    siteName && setSiteName(siteName)
  }, [])

  return (
    <div className="App">
      <Reviews siteName={siteName}/>
    </div>
  )
}
